import { render, staticRenderFns } from "./frontorderreturn-applyreturn.vue?vue&type=template&id=585c8d46&scoped=true&"
import script from "./frontorderreturn-applyreturn.vue?vue&type=script&lang=ts&"
export * from "./frontorderreturn-applyreturn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c8d46",
  null
  
)

export default component.exports